var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('extended-help-message',{staticClass:"editor-buttons-help-view p-2",attrs:{"message":_vm.$t('chatkeeper_editor_buttons_help_view'),"items":{
    'chatkeeper_editor_buttons_help_view_example': _vm.$t('chatkeeper_editor_buttons_help_view_example'),
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }